import { jwt } from 'angular';

export function checkAuthOnRun( authManager: jwt.IAuthManagerServiceProvider ) {
  authManager.checkAuthOnRefresh();
  authManager.redirectWhenUnauthenticated();
}

checkAuthOnRun.$inject = [ 'authManager' ];



// WEBPACK FOOTER //
// ./app/run/check-auth-on-run.ts